import type { VcnManagementCardRow } from './types'

/**
 * A card's identity for selection, paging merge, and ag-grid's row id.
 *
 * WEX merchant_log_id and MARQETA card_public_key live in separate spaces, so
 * the token alone is not unique. Same shape as terminate's identity
 * (`provider:virtualCardKey`): ticking a WEX card must not also tick a MARQETA
 * card that happens to share the token string.
 */
export function cardKeyOf(row: VcnManagementCardRow): string {
  return `${row.provider}:${row.virtualCardKey}`
}
